import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import type { AppRole } from '@disenchantment/shared';
import { hasMinAppRole } from '@disenchantment/shared';
import { useAuth } from './useAuth';

type Props = {
  children: ReactNode;
  minimum: AppRole;
  fallback?: string;
};

/**
 * Hides owner/admin routes entirely — redirects if role is insufficient.
 * Moderation placeholders will use admin/moderator minimums in a later phase.
 */
export function RoleRoute({ children, minimum, fallback = '/dashboard' }: Props) {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-sm text-zinc-400">
        Loading…
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  if (!hasMinAppRole(user.appRole, minimum)) {
    return <Navigate to={fallback} replace />;
  }

  return children;
}
